export enum LoaderTypeOptions {
	product = 'product',
	horizontal = 'horizontal',
}

export const loaderStyleClass = {
	[LoaderTypeOptions.product]: 'grey-skeleton-loader product-placeholder product-list-grid__item',
	[LoaderTypeOptions.horizontal]: 'grey-skeleton-loader horizontal-product-placeholder',
};